module.exports = __webpack_public_path__ + "media/phone_code.58ab072c.mp3";